import React from 'react';
import FormHelp from '../FormHelp/FormHelp';
import { TooltipPlacement } from '../../../../atoms/Tooltip';
import { createDescribedById } from '../FormLabel/utilities';
import extendClassName from '../../../../../lib/bemUtils/bem';

type FormsFieldsetProps = {
  children?: React.ReactNode;
  className?: string;
  modifier?: string;
  legend?: string;
  id?: string;
  helpText?: string;
};

export default function FormsFieldset(props: FormsFieldsetProps) {
  return (
    <fieldset className={extendClassName(props.className || 'form-fieldset', props.modifier)}>
      {props.legend && (
        <legend className="form-fieldset__legend">
          <span className="form-fieldset__legend-title">
            {props.legend}
            {props.id && props.helpText && (
              <FormHelp
                id={createDescribedById(props.id)}
                helpText={props.helpText}
                tooltipPlacement={TooltipPlacement.TOP}
              />
            )}
          </span>
        </legend>
      )}
      {props.children}
    </fieldset>
  );
}
